import React, { FunctionComponent, ReactElement } from 'react';
import { ActivityIndicator, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import PlusIcon from '../../../assets/images/plus-icon.svg';
import Theme from '../../../theme';
import theme from '../../../theme';
import { defaultScale } from '../../../utils/scaling';

interface IProps {
  isSetup: boolean;
  textLine1: {
    notSetup: string;
    isSetup: string;
  };
  textLine2: {
    notSetup: string;
    isSetup: string;
  };
  icon: (color: string) => ReactElement<{ color: string }>;
  onPress: () => void;
  loading?: boolean;
  disabled?: boolean;
}

const PLUS_ICON_SIZE = defaultScale(18);

enum ButtonState {
  IS_SETUP,
  NOT_SETUP,
  DISABLED,
}

const colorMap = {
  [ButtonState.IS_SETUP]: Theme.TEXT_DARK,
  [ButtonState.NOT_SETUP]: Theme.GREY_MEDIUM,
  [ButtonState.DISABLED]: Theme.GREY_MEDIUM,
};

export const BoostIcon: FunctionComponent<IProps> = ({
                                                       icon,
                                                       onPress,
                                                       isSetup,
                                                       textLine1,
                                                       textLine2,
                                                       loading = false,
                                                       disabled = false,
                                                     }) => {

  const getButtonState = () => {
    if (disabled) {
      return ButtonState.DISABLED;
    }
    if (isSetup) {
      return ButtonState.IS_SETUP;
    }
    return ButtonState.NOT_SETUP;
  };

  const state = getButtonState();
  const color = colorMap[state];

  return (
    <TouchableOpacity onPress={onPress} style={styles.container} disabled={disabled || loading}>
      <View style={styles.iconContainer}>
        {
          !isSetup && !disabled &&
          <PlusIcon color={theme.PRIMARY} width={PLUS_ICON_SIZE} height={PLUS_ICON_SIZE} style={styles.plusIcon} />
        }
        {
          loading &&
          <ActivityIndicator animating color={color} />
        }
        {
          !loading &&
          icon(color)
        }
      </View>

      <Text style={[styles.text, { color }]}>{isSetup && !disabled ? textLine1.isSetup : textLine1.notSetup}</Text>
      <Text style={[styles.text, { color }]}>{isSetup && !disabled ? textLine2.isSetup : textLine2.notSetup}</Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    width: defaultScale(80),
  },
  iconContainer: {
    width: defaultScale(52),
    height: defaultScale(40),
    justifyContent: 'center',
    alignItems: 'center',
  },
  plusIcon: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 3,
  },
  text: {
    ...Theme.textStyle.small,
  },
});
